module.exports = __webpack_public_path__ + "img/016.b6fb2e09.jpg";